import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { useStore } from 'vuex'

declare const gapi: any


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayStoreFinder',
  props: {
    packageName: {}
  },
  emits: ['update:packageName'],
  setup(__props: any, { emit }) {

const store = useStore()




const showDialog = ref(false)
const container = ref<HTMLElement>(null)

function isHttps(): boolean {
  return location.protocol === 'https:'
}

async function loadPlayStore(): Promise<void> {
  showDialog.value = true

  const { value } = await store.dispatch('createWebToken')
  const url = `https://play.google.com/work/embedded/search?token=${value}&mode=SELECT`

  gapi.load('gapi.iframes', () => {
    const options = {
      url,
      where: container.value,
      attributes: { style: 'width: 1000px; height:900px', scrolling: 'yes' },
    }
    const iframe = gapi.iframes.getContext().openChild(options)
    iframe.register(
      'onproductselect',
      async function (event) {
        if (event.packageName?.length > 0) {
          emit('update:packageName', event.packageName)
        }
        showDialog.value = false
      },
      gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
    )
  })
}

return (_ctx: any,_cache: any) => {
  const _component_DodoIcon = _resolveComponent("DodoIcon")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!
  const _component_PrimeDialog = _resolveComponent("PrimeDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    isHttps
      ? (_openBlock(), _createBlock(_component_DodoColumn, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_DodoButton, {
              square: "",
              variant: "solid",
              color: "info",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (loadPlayStore()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DodoIcon, { name: "search" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_PrimeDialog, {
      visible: showDialog.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
      modal: "",
      header: "Find app in Play Store",
      style: { width: '65vw' },
      breakpoints: { '960px': '75vw', '641px': '100vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "container",
          ref: container,
          style: {"width":"1000px","height":"900px"}
        }, null, 512)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})